import { BlocksActions, BlocksActionTypes } from "actions";
import { BlockInterface } from "interfaces/block.interface";
import { PageInterface } from "interfaces/page.interface";

interface BlocksState {
  blocks: PageInterface<BlockInterface>;
  loading: boolean;
  error: string | null;
}

const initialState: BlocksState = {
  blocks: {
    meta: {
      page: 1,
      take: 10,
      itemCount: 0,
      pageCount: 0,
      hasPreviousPage: false,
      hasNextPage: false,
    },
    data: [],
  },
  loading: false,
  error: null,
};

const blocksReducer = (
  state = initialState,
  action: BlocksActions
): BlocksState => {
  switch (action.type) {
    case BlocksActionTypes.FETCH_BLOCKS_REQUEST:
      return { ...state, loading: true, error: null };
    case BlocksActionTypes.FETCH_BLOCKS_SUCCESS:
      return { ...state, loading: false, blocks: action.payload };
    case BlocksActionTypes.FETCH_BLOCKS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default blocksReducer;
